<template>
  <v-dialog v-model="visible" max-width="600px">
    <v-card>
      <v-toolbar color="#f9f9f9" flat>
        <v-toolbar-title>职业类别查询</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container>
        <v-layout>
          <v-flex>
            <label class="v-label theme--light">选择职业</label>
            <JobCategory :comId="comId" v-model="category" class="job-category"></JobCategory>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <div class="v-input theme--light">
              <div class="v-input__control">
                <div class="v-input__slot">
                  <label
                    aria-hidden="true"
                    class="v-label theme--light"
                    style="left: 0px; right: auto; position: relative;"
                  >职业代码</label>
                  {{ category.code }}
                </div>
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper"></div>
                </div>
              </div>
            </div>
            <!-- <v-input label="职业代码">{{ category.code }}</v-input> -->
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <!-- <label class="v-label theme--light">职业类别</label>
            <span>{{ category.level }}</span>-->
            <div class="v-input theme--light">
              <div class="v-input__control">
                <div class="v-input__slot">
                  <label
                    aria-hidden="true"
                    class="v-label theme--light"
                    style="left: 0px; right: auto; position: relative;"
                  >职业类别</label>
                  {{ category.level === 0?'不承保':category.level}}
                </div>
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper"></div>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import JobCategory from "@/components/Order/JobCategory";
export default {
  components: {
    JobCategory
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    comId:{
      type:String,
      default:'1001'
    }
  },
  data() {
    return {
      category: {
        name: "",
        code: "",
        level: ""
      }
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  methods: {
    close() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss">
.job-category {
  .v-input {
    width: 400px;
  }
}
</style>


